module.exports = __webpack_public_path__ + "static/media/icon_key.ec5750ae.svg";